import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator, BreadcrumbPage } from "@/components/ui/breadcrumb";
import { useLanguage } from "@/hooks/useLanguage";
import bgehLogo from "@/assets/logos/bgeh.png";

const CaseStudyHero = () => {
  const { t, localizePath } = useLanguage();
  const p = "caseStudyBgeh.hero";
  return (
    <section className="relative pt-36 md:pt-48 pb-16 md:pb-24 overflow-hidden bg-gradient-to-b from-chathero-mint/10 to-background">
      <div className="absolute top-0 right-0 w-96 h-96 bg-chathero-mint/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-chathero-orange/5 rounded-full blur-3xl" />
      <div className="container mx-auto px-4 relative z-10">
        <Breadcrumb className="mb-8">
          <BreadcrumbList>
            <BreadcrumbItem><BreadcrumbLink asChild><Link to={localizePath("/")} className="text-muted-foreground hover:text-primary">{t(`${p}.home`)}</Link></BreadcrumbLink></BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem><span className="text-muted-foreground">{t(`${p}.caseStudies`)}</span></BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem><BreadcrumbPage className="text-chathero-mint font-medium">{t(`${p}.breadcrumbCurrent`)}</BreadcrumbPage></BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8"><img src={bgehLogo} alt="Big Green Egg Head Logo" className="h-16 md:h-20 mx-auto object-contain" /></div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-primary leading-tight mb-6 animate-fade-in">{t(`${p}.title`)}</h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto animate-fade-in" style={{ animationDelay: "0.1s" }}>{t(`${p}.description`)}</p>
        </div>
      </div>
    </section>
  );
};
export default CaseStudyHero;
